// Exposures
// TODO - Documentar
import * as con from "../../GlobalConstants"

import { EDIT_COMMAND, PREPAY_EXPOSURE_COMMAND, REMOVE_COMMAND, VIEW_ANNOTATIONS_COMMAND } from '../transactionTable/TransactionTableConstants'

// Style
import "../ComponentsGlobalStyle.css"
import { TransactionTable } from '../transactionTable/TransactionTable'
import TransactionTableVisualizer from './TransactionTableVisualizer'
import { ExposuresHook, useTransactionAnnotations, useTransactionFilters } from '../hooks/TransactionsHooks'
import { allExposureColumns, selectedExposureColumns } from '../../utils/transactionFunctions'
import { useDispatch } from "react-redux"
import { addTransaction, deleteTransaction, updateTransaction } from "../../store/slices/transactionsSlice"

function TableExposures() {

  // Transaction
  const trans = ExposuresHook()
  const dispatch = useDispatch()
  const { filterFun, searchFun } = useTransactionFilters()
  const getAnnotations = useTransactionAnnotations(con.EXPOSURES)
    
  // Columns
  const columns = selectedExposureColumns.map(col => allExposureColumns[col[con.ID]])

  return (
         
            <TransactionTableVisualizer transactionType={con.EXPOSURES}>             
                    <TransactionTable transactionType={con.EXPOSURES}
                            columnArray={columns} 
                            dataDictionary={trans} 
                            setRow={(id, vals) =>
                              dispatch(updateTransaction({
                                transactionType: con.EXPOSURES,
                                id,
                                values: vals
                              }))
                            }
                            addRow={(vals) =>
                              dispatch(addTransaction({
                                transactionType: con.EXPOSURES,
                                values: vals
                              }))
                            }
                            deleteRow={(id) =>
                              dispatch(deleteTransaction({
                                transactionType: con.EXPOSURES,
                                id
                              }))
                            }
                            getAnnotations={getAnnotations}
                            commands={[EDIT_COMMAND, VIEW_ANNOTATIONS_COMMAND, PREPAY_EXPOSURE_COMMAND, REMOVE_COMMAND]}
                            filterFunction={filterFun}
                            searchFunction={searchFun}/>
            </TransactionTableVisualizer>
 
  )
}

export default TableExposures